import React from 'react';

import { defineMessage, useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- TODO: migrate to @atlaskit/primitives/compiled
import Box from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- TODO: migrate to @atlaskit/primitives/compiled
import Inline from '@atlaskit/primitives/inline';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- TODO: migrate to @atlaskit/primitives/compiled
import Text from '@atlaskit/primitives/text';
import { token } from '@atlaskit/tokens';

export type FieldOptionsCardProps = {
	fieldId: string;
	fieldName: string;
	fieldIcon?: React.ReactNode;
	optionsAdded: string[];
	optionsDisabled: string[];
	optionsRenamed: {
		new: string;
		old: string;
	}[];
};

const addedTitle = defineMessage({
	id: 'ai-mate-jira-admin-agent.jira-admin-agent.FieldOptionsCard.createTitle.non-final',
	defaultMessage: 'Add options',
	description: 'Name of the list containing the options being added',
});

const renamedTitle = defineMessage({
	id: 'ai-mate-jira-admin-agent.jira-admin-agent.FieldOptionsCard.renameTitle.non-final',
	defaultMessage: 'Rename options',
	description: 'Name of the list containing the options being renamed',
});

const disabledTitle = defineMessage({
	id: 'ai-mate-jira-admin-agent.jira-admin-agent.FieldOptionsCard.disableTitle.non-final',
	defaultMessage: 'Disable options',
	description: 'Name of the list containing the options being disabled',
});

const styles = cssMap({
	fieldWrapper: {
		paddingTop: token('space.150'),
		paddingBottom: token('space.150'),
	},
	optionsWrapper: {
		paddingTop: token('space.150'),
		paddingBottom: token('space.150'),
	},
});

const getChange = (oldName: string, newName: string) => `${oldName} -> ${newName}`;

export const FieldOptionsCard = ({
	fieldIcon,
	fieldName,
	optionsAdded,
	optionsDisabled,
	optionsRenamed,
}: FieldOptionsCardProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Box>
			<Box xcss={styles.fieldWrapper}>
				<Inline space="space.100">
					{fieldIcon}
					<Text>{fieldName}</Text>
				</Inline>
			</Box>
			{optionsRenamed.length > 0 && (
				<Box xcss={styles.optionsWrapper}>
					<Text>{formatMessage(renamedTitle)}</Text>
					<ul>
						{optionsRenamed.map((rename, idx) => (
							<li key={idx}>
								<Text>{getChange(rename.old, rename.new)}</Text>
							</li>
						))}
					</ul>
				</Box>
			)}
			{optionsDisabled.length > 0 && (
				<Box xcss={styles.optionsWrapper}>
					<Text>{formatMessage(disabledTitle)}</Text>
					<ul>
						{optionsDisabled.map((name, idx) => (
							<li key={idx}>
								<Text>{name}</Text>
							</li>
						))}
					</ul>
				</Box>
			)}
			{optionsAdded.length > 0 && (
				<Box xcss={styles.optionsWrapper}>
					<Text>{formatMessage(addedTitle)}</Text>
					<ul>
						{optionsAdded.map((name, idx) => (
							<li key={idx}>
								<Text>{name}</Text>
							</li>
						))}
					</ul>
				</Box>
			)}
		</Box>
	);
};
